import { OOFProvidersEnum } from '../../../common/enums/oofproviders.enum';
import { FlowTypes } from '../../../common/models/order/order.model';
import { OrderRoutes } from '../orders-routes.enum';
import { FlowContext, FlowDefinition } from './flow.types';

export const requiresWindstreamRequalification = (ctx: FlowContext): boolean =>
    ctx.isResidential() && !ctx.isSMB()
    && ctx.currentFlow() === FlowTypes.INTERNET
    && ctx.getProvider().toLowerCase() === OOFProvidersEnum.WINDSTREAM
    && !!ctx.order()?.qualificationSnapshot?.Internet
    && !ctx.canReuseQualifiedSelections();

const afterInternetOffers = (ctx: FlowContext): string =>
    requiresWindstreamRequalification(ctx) ? OrderRoutes.CREDIT_CHECK
        : ctx.allowShippingAddressChange() ? OrderRoutes.ALTERNATE_SHIPPING
        : (ctx.isSecurityAnswerRequired() || ctx.isSecurityPinRequired()) ? OrderRoutes.CUSTOMER_ACCOUNT_SETUP
        : OrderRoutes.PRODUCT_SUMMARY;

const lastInternetOffersPage = (ctx: FlowContext): string =>
    ctx.internetClosingOffersAvailable() ? OrderRoutes.CLOSING_OFFERS : OrderRoutes.ADDITIONAL_INTERNET_OFFERS;

export const INTERNET_FLOW: FlowDefinition = [
    {
        route: OrderRoutes.INTERNET_PACKAGE_SELECTION,
        next: OrderRoutes.CREDIT_CHECK,
        back: OrderRoutes.BUNDLE_HOMEPAGE
    },
    {
        route: OrderRoutes.ADVANCED_BILL_PAYMENT,
        next: OrderRoutes.ADDITIONAL_INTERNET_OFFERS,
        back: OrderRoutes.BUNDLE_HOMEPAGE
    },
    {
        route: OrderRoutes.ADDITIONAL_INTERNET_OFFERS,
        next: ctx => !requiresWindstreamRequalification(ctx) && ctx.internetClosingOffersAvailable()
            ? OrderRoutes.CLOSING_OFFERS
            : afterInternetOffers(ctx),
        back: OrderRoutes.INTERNET_PACKAGE_SELECTION
    },
    {
        route: OrderRoutes.CLOSING_OFFERS,
        next: afterInternetOffers,
        back: OrderRoutes.ADDITIONAL_INTERNET_OFFERS
    },
    {
        route: OrderRoutes.ALTERNATE_SHIPPING,
        next: ctx => (ctx.isSecurityAnswerRequired() || ctx.isSecurityPinRequired())
            ? OrderRoutes.CUSTOMER_ACCOUNT_SETUP
            : OrderRoutes.PRODUCT_SUMMARY,
        back: lastInternetOffersPage
    },
    {
        route: OrderRoutes.CUSTOMER_ACCOUNT_SETUP,
        next: OrderRoutes.PRODUCT_SUMMARY,
        back: ctx => ctx.allowShippingAddressChange()
            ? OrderRoutes.ALTERNATE_SHIPPING
            : lastInternetOffersPage(ctx)
    },
    {
        route: OrderRoutes.PRODUCT_SUMMARY,
        next: OrderRoutes.ORDER_OPTIONS,
        back: ctx => (ctx.isSecurityAnswerRequired() || ctx.isSecurityPinRequired()) ? OrderRoutes.CUSTOMER_ACCOUNT_SETUP
            : ctx.allowShippingAddressChange() ? OrderRoutes.ALTERNATE_SHIPPING
            : lastInternetOffersPage(ctx)
    }
];
